import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Media } from '@klickdata/core/media/src/media.model';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-images-uploader-server-aws-without-viewer',
    templateUrl: './images-uploader-server-aws-without-viewer.component.html',
    styleUrls: ['./images-uploader-server-aws-without-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesUploaderServerAwsWithoutViewerComponent implements OnInit {
    @Input() source: 'AWS' | 'SERVER' = 'AWS';
    @Input() scope: AppScope;
    @Output() onMediaReady: EventEmitter<Media> = new EventEmitter<Media>();
    @Output() saving: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() dropLabel: string = $localize`Drop files`;
    @Input() fileTooltip: string = $localize`Upload file`;
    @Input() allowedMimeType: string[] = ['image/png', 'image/jpg', 'image/jpeg'];
    constructor() {}

    ngOnInit(): void {}
}
